var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exercise-video-header"},[_c('ButtonBreadcrumbs',{attrs:{"prevPageName":_vm.prevPageName},on:{"to-route":_vm.backToPreviousPage}}),_c('div',{staticClass:"exercise-title"},[_vm._v(_vm._s(_vm.currentExercise.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }